module.exports = __webpack_public_path__ + "img/zhu_xc3.56f0a8f1.jpg";